/**
 * This Component houses the board that users will see upon entering the application. It will contain a navigation pane at the top
 * and house the content of the application via a series of pages.
 */

import {  Component, OnInit } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs/internal/Observable';
import { isNullOrUndefined } from '../common/common-functions.domain';
import { loadBoardColors } from './+store/board-state/board-state.actions';
import { selectBoardColors } from './+store/board-state/board-state.selectors';
import { BoardState } from './+store/board-state/board-state.reducer';

@UntilDestroy()
@Component({
    selector: 'bhub-board',
    templateUrl: './board.component.html',
    styleUrls: ['./board.component.scss'],
    standalone: false
})
export class BoardComponent implements OnInit {


  private boardColors: Observable<string[]> = this.store.select(selectBoardColors);
  private localBoardColors: string[];
  constructor(
    private store: Store<BoardState>
    ) { }

  ngOnInit(): void {
      this.printColors();
      this.store.dispatch(loadBoardColors());

      this.boardColors.subscribe( colors => {
        if(colors != null){
          this.localBoardColors = colors;
          this.printColors();
        }
      });
  }

  private printColors(){
    if(!isNullOrUndefined(this.localBoardColors)){
       this.localBoardColors.forEach(color => console.log(color));
    } else{
      console.log('no colors');
    }
  }


}
